export default "__VITE_ASSET__CMSEOM0x__"